import { render } from "./B2bPageCreateCover.vue?vue&type=template&id=03efcdeb&scoped=true&lang=pug"
import script from "./B2bPageCreateCover.vue?vue&type=script&lang=js"
export * from "./B2bPageCreateCover.vue?vue&type=script&lang=js"

import "./B2bPageCreateCover.vue?vue&type=style&index=0&id=03efcdeb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03efcdeb"]])

export default __exports__